import { lazy, Suspense, memo, useCallback } from 'react'
import { useRecoilValue } from 'recoil'
import CircularProgress from '@mui/material/CircularProgress'

import { isUserTypeDoctorSelector } from 'state/pmsState'
import useCsqState from 'state/useCsqState'
import RequestLoading from '../request/RequestLoading'

const IrishLifeForm = lazy(() => import('./irishLife/IrishLifeForm'))
const RoyalLondonForm = lazy(() => import('./royalLondon/RoyalLondonForm'))

function FormMapper({ insurerCode, ...props }) {
    const isUserDoctorType = useRecoilValue(isUserTypeDoctorSelector)
    const csqState = useCsqState()

    const adaptFormConfig = useCallback((config) => {
        if (!isUserDoctorType) {
            // If logged on user is not a doctor, hide any steps that are restricted to a doctor user type
            // This is desiged to stop the nurse user opening the Submit/Payment tab and accessing the
            // payment dropdown with IBAN details etc.
            config.steps = config.steps.filter(e => e.restrictToDoctor === false)
        }

        if (config.model) {
            // If model exists, then this is a Condition Specific Questionnaire.
            config.isConditionSpecific = true
            // For CSQs, the first time they load we need to initialize the model        
            csqState.initConditionSpecificModel(config.model)
        }

        return config
    }, [])

    return (
        <Suspense fallback={(
            <RequestLoading
                message='Preparing the patient form for review…'
            />
        )}>

            {insurerCode === 'IRIL' && <IrishLifeForm {...props} adaptConfig={adaptFormConfig} />}
            {insurerCode === 'ROYLI' && <RoyalLondonForm {...props} adaptConfig={adaptFormConfig} />}

        </Suspense>
    )
}

export default memo(FormMapper)